module.exports = {"id":"173210","name":"Claudio Marchisio","rating":"84","photo":"./data/images/photos/2/173210.png","club":{"name":"Juventus","logo":"./data/images/clubs/Juventus.png"},"positions":["MC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ClaudioMarchisio0.json
// module id = 828
// module chunks = 0